import { PeriodOptionSet } from '../period-selection/createPeriodOptions.ts';
import { getDefaultPeriodRange } from '../period-selection/defaultPeriodRange.ts';
import { ReportSettings } from './reportSettings.ts';

export function getDefaultReportSettings(
    periodOptionSet: PeriodOptionSet,
    defaultTargetValue: string,
): ReportSettings {
    return {
        reportType: 'Availability',
        resolution: 'Weeks',
        mainValue: 'Percentage',
        shiftsDisplay: 'Joined',
        visibleShifts: ['morning', 'evening', 'night'],
        showOperators: true,
        workdays: true,
        weekends: false,
        ...getDefaultPeriodRange(periodOptionSet, 'Weeks'),
        availabilityTargetValue: defaultTargetValue,
    };
}
